<template>
    <v-container :class="{'primary': !isDesktop}">
        <v-row>
            <v-col cols="12" :class="{'pa-0': !isDesktop}">
                <div class="d-flex flex-column">
                    <slot></slot>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>
<style scoped>
.container {
    align-items: center;
    display: flex;
    flex: 1;
}
</style>
<script>
export default {}
</script>